import { faX } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Transition } from '@headlessui/react'
import React, { Fragment } from 'react'

const Slider = (props) => {
    const handleCloseSlider = () => {
        props.handleCloseSlider()
    }

    return (
        <Transition
            as={Fragment}
            show={props.showSlider}
        >
            <div className="absolute w-full h-full top-0 left-0 bg-black/30 z-30 flex justify-end">
                <Transition.Child
                    enter="transition ease-in-out duration-300 transform"
                    enterFrom="translate-x-full"
                    enterTo="translate-x-0"
                    leave="transition ease-in-out duration-300 transform"
                    leaveFrom="translate-x-0"
                    leaveTo="translate-x-full"
                    className="md:w-2/3 w-[98%]"
                >
                    <div className='w-full h-full bg-white flex flex-col'>
                        <div className="w-full py-3.5 px-4 bg-primary text-white flex justify-between items-center">
                            <p className='md:text-base text-xs'>
                                { props.chartAgent?.UserName }'s 
                                { props.commissionPayoutContent ? ' commission and payout ' : props.title }
                                in detail
                            </p>
                            <button onClick={ handleCloseSlider } className='cursor-pointer px-2 hover:opacity-70 focus-visible:outline-none'>
                                <FontAwesomeIcon icon={ faX } className='h-3 w-3' />
                            </button>
                        </div>
                        
                        <div className='flex-1 w-full flex flex-col md:px-7 md:py-5 p-3 md:gap-7 gap-4'>
                            { props.children }
                        </div>
                    </div>
                </Transition.Child>
            </div>
        </Transition>
    )
}

export default Slider